import { useEffect } from "react";
import StoreDashboard from "./StoreDashboard";

export default function StoreList() {
  useEffect(() => {
    document.title = "RaceTrack Pitstop | Stores";
  }, []);

  return <StoreDashboard />;
}
